import React, { useEffect } from 'react';
import TabPanel, { Item as TabItem } from "devextreme-react/tab-panel";
import Guid from "../../models/Guid";
import useApi from "../../hooks/useApi";
import IInfoReservationEntete from "../../models/IInfoReservationEntete";
import { format } from "date-fns";

interface ICalendrierInfoReservationProps {
  idReservation: Guid
}

function CalendrierInfoReservation({ idReservation }: ICalendrierInfoReservationProps) {
  const { data, getData } = useApi<IInfoReservationEntete>(`reservation/${idReservation}/inforeservation`)
  useEffect(() => {
    if (!idReservation) return;
    getData();
  }, [idReservation])

  return !data ? null : (
    <div key={`infoReservation-${data.idReservationEntete}`} style={{ maxHeight: "2rem", padding: "0.5rem" }}>
      <div>Informations sur la sélection</div>
      <TabPanel>
        <TabItem title={data?.noConfirmation}>
          <div style={{ display: "flex", gap: "0.5rem", flexDirection: "row", height: "100%" }}>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}>
              <div>Réservation #:</div>
              <div><b>{data?.noConfirmation}</b></div>
              <div>Date d'arrivée:</div>
              <div>{data?.dateArrivee && format(data?.dateArrivee, "dd-MM-yyyy HH:mm")}</div>
              <div>Date de départ:</div>
              <div>{data?.dateDepart && format(data?.dateDepart, "dd-MM-yyyy HH:mm")}</div>
              <div>Nb. Personnes:</div>
              <div>{data?.nombrePersonnes}</div>
              <div>Nb. d'unite:</div>
              <div>{data?.nombreUnites}</div>
            </div>
            <div style={{ flex: 1, display: "flex", flexDirection: "column", maxWidth: "15%" }}>
              <div>Unité(s) réservé(es):</div>
              <div className={"unite-reserve"} style={{ border: "1px solid #00000040", flex: 1, padding: "0.5rem" }}>
                {data.infoReservationDetails?.map(infoDetail => <div key={`uniteReserver-${infoDetail.idReservationDetail}`}>{infoDetail.description}</div>)}
              </div>
            </div>
            <div style={{ flex: 2 }}>
              <div>Notes:</div>
              <div style={{ border: "1px solid #00000040", padding: "0.5rem" }}>{data.notes}</div>
            </div>
          </div>
        </TabItem>
      </TabPanel>
    </div>
  );
}

export default CalendrierInfoReservation;